import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Alert, AlertDescription } from '../components/ui/alert';
import { Loader2, ShieldCheck, CheckCircle2, AlertCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const DesbloqueoCuentaPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const correo = params.get('correo') || '';
  const token = params.get('token') || '';

  const [estado, setEstado] = useState('idle'); // idle | loading | ok | error
  const [mensaje, setMensaje] = useState('');

  const confirmar = async () => {
    setEstado('loading');
    setMensaje('');
    try {
      const r = await axios.post(`${API}/api/auth/desbloqueo/confirmar`, { correo, token });
      setEstado('ok');
      setMensaje(r.data?.message || 'Tu cuenta fue desbloqueada.');
    } catch (err) {
      setEstado('error');
      const d = err.response?.data?.detail;
      setMensaje(typeof d === 'string' ? d : 'El enlace de desbloqueo es inválido o expiró.');
    }
  };

  const invalido = !correo || !token;

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <Card className="w-full max-w-md border-slate-200 shadow-sm">
        <CardHeader className="text-center">
          <div className="mx-auto mb-2 w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 text-slate-700" />
          </div>
          <CardTitle className="text-2xl">Desbloqueo de cuenta</CardTitle>
          <CardDescription>
            {correo ? <>Cuenta: <strong>{correo}</strong></> : 'Enlace de desbloqueo'}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {invalido && (
            <Alert variant="destructive">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>El enlace no es válido. Vuelve a solicitar el desbloqueo desde la pantalla de acceso.</AlertDescription>
            </Alert>
          )}

          {estado === 'ok' && (
            <Alert data-testid="desbloqueo-ok">
              <CheckCircle2 className="h-4 w-4" />
              <AlertDescription>{mensaje}</AlertDescription>
            </Alert>
          )}

          {estado === 'error' && (
            <Alert variant="destructive" data-testid="desbloqueo-error">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>{mensaje}</AlertDescription>
            </Alert>
          )}

          {estado !== 'ok' ? (
            <Button
              className="w-full h-11"
              onClick={confirmar}
              disabled={invalido || estado === 'loading'}
              data-testid="desbloqueo-confirmar-btn"
            >
              {estado === 'loading' ? (
                <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Desbloqueando…</>
              ) : 'Desbloquear mi cuenta'}
            </Button>
          ) : (
            <Button className="w-full h-11" onClick={() => navigate('/login')} data-testid="desbloqueo-ir-login-btn">
              Ir a iniciar sesión
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default DesbloqueoCuentaPage;
